export const GetAIDescription = (api, product) => {
    return api.post(`/api/v1/AIDescription/getDescriptionFromAIAsync`, product)
}

export const GetAIDescriptionFromDatabase = (api, index) => {
    return api.get(`/api/v1/AIDescription/getAIDescriptionFromDatabaseAsync?index=${index}`)
}